declare namespace $ {

	type $mol_link__title_shm_hitalama_vk_lists_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_vk_lists_2 = $mol_type_enforce<
		({ 
			'create': boolean,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_paragraph__title_shm_hitalama_vk_lists_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__title_shm_hitalama_vk_lists_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_hitalama_vk_lists_5 = $mol_type_enforce<
		({ 
			'edit': ReturnType< $shm_hitalama_vk_lists['ref_str'] >,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_button_minor__title_shm_hitalama_vk_lists_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_vk_lists_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['remove_list'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_vk_lists_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_shm_hitalama_vk_lists_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['group_photo_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__sub_shm_hitalama_vk_lists_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_vk_lists_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['groups'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_vk_lists_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_list__sub_shm_hitalama_vk_lists_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['lists'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_section__title_shm_hitalama_vk_lists_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['title'] >
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_shm_hitalama_vk_lists_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $shm_hitalama_vk_lists_creating__token_shm_hitalama_vk_lists_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['token'] >
		,
		ReturnType< $shm_hitalama_vk_lists_creating['token'] >
	>
	type $shm_hitalama_vk_lists_editing__token_shm_hitalama_vk_lists_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['token'] >
		,
		ReturnType< $shm_hitalama_vk_lists_editing['token'] >
	>
	type $shm_hitalama_vk_lists_editing__list_shm_hitalama_vk_lists_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_lists['list_editing'] >
		,
		ReturnType< $shm_hitalama_vk_lists_editing['list'] >
	>
	export class $shm_hitalama_vk_lists extends $mol_list {
		current_view( ): ReturnType< $shm_hitalama_vk_lists['Main'] >
		Open_create( ): $mol_link
		name( id: any): string
		Name( id: any): $mol_paragraph
		ref_str( id: any): string
		Edit( id: any): $mol_link
		remove_list( id: any, next?: any ): any
		Remove( id: any): $mol_button_minor
		List_head( id: any): $mol_view
		group_photo_uri( id: any): string
		Photo( id: any): $mol_image
		Group( id: any): $mol_view
		groups( id: any): readonly(any)[]
		Groups( id: any): $mol_view
		List( id: any): $mol_list
		lists( ): readonly(any)[]
		Lists( ): $mol_list
		list_editing( ): $shm_hitalama_vk_list
		title( ): string
		token( ): $shm_hitalama_vk_token | null
		sub( ): readonly(any)[]
		Main( ): $mol_section
		Creating( ): $shm_hitalama_vk_lists_creating
		Editing( ): $shm_hitalama_vk_lists_editing
	}
	
}

//# sourceMappingURL=lists.view.tree.d.ts.map